<template>
  <div class="w-full h-full flex flex-col items-center justify-center p-8">
    <div class="w-2/3 -mt-24 pointer-events-none min-h-24">
      <LottieComponent :src="$constants.AFFILIATION.LOTTIES.EMPTY" loop />
    </div>
    <div class="py-2"></div>
    <div class="text-center text-2xl font-bold">Aucune transaction trouvée</div>
    <div class="py-1"></div>
    <div class="text-center text-lg">
      Les gains par affiliation s'afficheront ici
    </div>
    <div class="py-1"></div>
    <button class="buttonComponent" @click="$emit('refresh')">
      Actualiser
    </button>
  </div>
</template>
